import Form from "../form";

export class ResetPasswordForm {
    private successMessage: HTMLElement;
    private formElement: HTMLFormElement;

    constructor() { }

    process(event: Event): void {
        this.formElement = document.querySelector('[data-component=ForgotPassword] form') as HTMLFormElement;
        this.successMessage = document.getElementById('success-message') as HTMLElement;

        const actionUrl = this.formElement.getAttribute('action');
        const form = new Form(actionUrl, this.formElement, 
            () => this.onSuccess(),
            (html: string) => this.onModelError(html));

        form.process(event);
    }

    private onSuccess(): void {
        this.displaySuccessMessage();
    }

    private onModelError(html: string): void {
        const viewcomponent =  document.querySelector('[data-component=ForgotPassword]');
        viewcomponent.innerHTML = html;
    }

    private displaySuccessMessage(): void {
        const userEmail = (document.querySelector('input[name="Email"]') as HTMLInputElement).value;
        const emailElement = document.querySelector('[data-email-target]') as Element;
        emailElement.textContent = userEmail;

        this.successMessage.style.display = 'block';
        this.formElement.style.display = 'none';
    }
}